import ContentstackLivePreview from '@contentstack/live-preview-utils';
import { ContentstackGatsby } from 'gatsby-source-contentstack/live-preview';

import { Logger } from 'services/logger';

import { isLivePreviewEnabled } from 'utils/featureFlags';
import { getTimelineConfig } from 'utils/livePreviewUtils';

export const contentstackLivePreviewSdk: any = (() => {
  try {
    if (typeof window === 'undefined' || !isLivePreviewEnabled) {
      return null;
    }

    if (!process.env.GATSBY_CONTENTSTACK_API_KEY) {
      throw new Error('Client api key token is not provided.');
    }

    if (!process.env.GATSBY_CONTENTSTACK_ENVIRONMENT) {
      throw new Error('Client environment value is not provided.');
    }

    if (!process.env.GATSBY_CONTENTSTACK_DELIVERY_TOKEN) {
      throw new Error('Client delivery token is not provided.');
    }

    if (!process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW_TOKEN) {
      throw new Error('Live Preview token is not provided.');
    }

    if (!process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW_HOST) {
      throw new Error('Live Preview host is not provided.');
    }

    const sdk = new ContentstackGatsby({
      api_key: process.env.GATSBY_CONTENTSTACK_API_KEY,
      environment: process.env.GATSBY_CONTENTSTACK_ENVIRONMENT,
      delivery_token: process.env.GATSBY_CONTENTSTACK_DELIVERY_TOKEN,
      live_preview: {
        preview_token: process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW_TOKEN,
        preview_host: process.env.GATSBY_CONTENTSTACK_LIVE_PREVIEW_HOST,
        enable: true,
      },
    });

    ContentstackLivePreview?.init?.({ stackSdk: sdk?.stackSdk });

    const timelineConfig = getTimelineConfig();

    return {
      ...(timelineConfig && { timelineConfig }),
      ...sdk,
    };
  } catch (err) {
    Logger.error('Error initializing contentstack live preview: ', err);
    return null;
  }
})();
